import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmVideoConfig, { McmVideoOrientation, McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';

const McmPackageCrossroadsPlatinum: TenantPackageConfig<McmOrderContext> = {
  id: 'cr_platinum',
  name: 'Crossroads Platinum',
  hideSavings: true,
  performables: [
    McmPhotoConfig,
    McmZillowConfig,
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.VIDEO_PHOTO,
        daytime: true
      },
    },
    {
      config: McmVideoConfig,
      metadata: {
        type: McmVideoType.PREMIUM,
        orientation: McmVideoOrientation.HORIZONTAL
      },
    },
  ],
  eligible: ({ buyer, parent }) => Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '50-60 Photos, Zillow 2D Floorplan + Zillow 3D, Drone Stills, Drone Video and Video Walk Through'
};

export default McmPackageCrossroadsPlatinum;
